import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductType } from '../models';
import { NavService } from '../providers/services/nav.service';
import { SearchService } from '../providers/services/search.service';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentService } from '../providers';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
  standalone: false,
})
export class SearchResultsComponent {
  constructor(
    public searchService: SearchService,
    public navService: NavService,
    public translateService: TranslateService,
    public equipmentService: EquipmentService,
    public router: Router
  ) {}

  navigateFromSearchResults = (item: ProductType) => {
    this.navService.searchBackButtonRoute = this.navService.currentRoute;
    this.navService.pageTitle = this.translateService.instant(
      'main.data.all_categories'
    );
    this.equipmentService.productTypes = undefined;
    this.searchService.isSearching = false;
    this.router.navigate([
      '/product-types',
      item.category_id,
      item.product_type_id,
    ]);
  };
}
